<template>
  <div>
    <aside
      v-show="drawer"
      class="v-navigation-drawer v-navigation-drawer--fixed v-navigation-drawer--open theme--light elevation-3"
      id="appDrawerx"
      style="height: 100%; margin-top: 0px; max-height: calc(100% - 0px); transform: translateX(0px); width: 260px;"
      data-booted="true"
    >
      <v-list three-line subheader>
        <v-subheader>
          {{$tc('event',2)}}
          <v-spacer />
          <v-btn
            v-if="isMobile"
            @click.stop="$emit('update:drawer', false)"
            class="text-xs-right"
            
            icon
          >
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <v-toolbar-side-icon
            v-if="isMobile"
            @click.stop="$emit('update:drawer', false)"
            class="text-xs-right"
          ></v-toolbar-side-icon> -->
        </v-subheader>

        <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
          <v-divider></v-divider>
          <template v-for="(event, index) in eventList">
            <v-divider v-if="index" inset :key="index +700"></v-divider>

            <v-list-tile @click="setEvent(event)" avatar :key="index +200">
              <!-- <v-list-tile-avatar>
                                <v-icon class="icon material-icons">event_note</v-icon>
              </v-list-tile-avatar>-->

              <v-list-tile-content>
                <v-list-tile-title>
                  {{`${event.minute.toString().padStart(2, '0')} :
                  ${event.second.toString().padStart(2, '0')}`}} - {{event.participant}}
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title >{{type == 'users'? formatUser(event.userId) :
                                    formatTeam(event.teamId)}}
                </v-list-tile-sub-title >-->
                <v-list-tile-sub-title
                  class="body-1 grey--text text--lighten-1"
                >{{ event.additionalContent }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn flat icon color="secondary">
                  <v-icon class="icon material-icons" @click="setEvent(event, true)">visibility</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </vue-perfect-scrollbar>
      </v-list>
    </aside>
    <!-- <v-navigation-drawer
          v-model="drawer"
          fixed
          app
          :dark="$vuetify.dark"
          width="260"
          id="appDrawerx"
        >
    </v-navigation-drawer>-->
    <div class="pt-0" :style="drawer&&!isMobile ?'padding-left: 260px !important;':''">
      <video-player
        v-if="match && match.video"
        :src="match.video"
        :time="time"
        :eventView="canCreateEvents"
        @addEvent="addEvent"
        @duration="updateTime"
      ></video-player>
      <youtube-player
        v-if="match && match.youtubeVideo"
        :src="match.youtubeVideo"
        :time="time"
        :eventView="canCreateEvents"
        @addEvent="addEvent"
        @duration="updateTime"
      ></youtube-player>
    </div>
    <v-dialog v-model="dialog" max-width="600px" style="z-index: 1000;">
      <v-card>
        <v-card-title class="pb-0">
          <span
            class="headline"
          >{{localEvent._id ? $tc('event') : $t('newModel', {field: $tc('event')})}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  type="number"
                  :label="$t('minute')"
                  min="1"
                  :max="maxMinute"
                  step="1"
                  maxlength="2"
                  :readonly="!canEditEvent"
                  :rules="valid ? [] : [v => rules.minNumber(v),  v => rules.maxNumber(v,'minute' ,maxMinute)]"
                  v-model.number="localEvent.minute"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  type="number"
                  :label="$t('second')"
                  min="0"
                  :max="maxSecond"
                  step="1"
                  maxlength="2"
                  :readonly="!canEditEvent"
                  :rules="valid ? [] : [v => rules.minNumber(v), v => rules.maxNumber(v,'second' ,maxSecond )]"
                  v-model.number="localEvent.second"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-if="type === 'teams'"
                  v-model="localEvent.teamId"
                  :items="teamList"
                  :rules="valid ? [] : [v=>rules.vacio(v, 'team')]"
                  :label="$t('select', {field: $tc('team')})"
                  required
                  :readonly="!canEditEvent"
                ></v-select>
                <v-select
                  v-model="localEvent.userId"
                  :items="users"
                  :label="$tc('user')"
                  :rules="valid || type =='teams' ? [] : [v=>rules.vacio(v, 'user')]"
                  :disabled="type === 'teams' && !localEvent.teamId"
                  :readonly="!canEditEvent"
                >
                  <template v-slot:selection="data">
                    <v-chip color="white" :selected="data.selected" class="chip--select-multi">
                      <v-avatar>
                        <img :src="data.item.photo" />
                      </v-avatar>
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-tile-avatar>
                      <img :src="data.item.photo" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="localEvent.additionalContent"
                  :label="$t('additionalContent')"
                  :readonly="!canEditEvent"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" small>{{$t('cancel')}}</v-btn>
          <template v-if="canEditEvent">
            <v-btn
              v-if="localEvent._id"
              @click="dialogDelete = true"
              color="error"
              :loading="loading"
              small
            >{{$t('delete')}}</v-btn>
            <v-btn @click="saveEvent()" :color="localEvent._id ? 'secondary' : 'success'" small>
              <span>{{localEvent._id ? $t('update') : $t('create')}}</span>
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400" style="z-index:1001;">
      <v-card>
        <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
        <v-card-text v-html="$t('confirmDelete', {field: $tc('event'), name: ''})"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" flat="flat" @click="dialogDelete = false">{{$t('cancel')}}</v-btn>

          <v-btn color="error" flat="flat" @click="deleteEvent()">
            <span v-if="loadingDelete">
              <v-progress-circular :size="20" :width="3" color="red" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('delete')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import VideoPlayer from '@/components/widgets/video/VideoPlayer'
import YoutubePlayer from '@/components/widgets/video/YoutubePlayer'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import queueToast from '@/helpers/queueToast'
import rules from '@/helpers/rules'

export default {
  components: { VuePerfectScrollbar, VideoPlayer, YoutubePlayer },
  props: {
    drawer: {
      type: Boolean,
      required: false,
      default: true
    },
    tabVideoView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [rules],
  data() {
    return {
      localEvent: {},
      eventId: '',
      duration: 0,
      valid: true,
      loading: false,
      loadingDelete: false,
      dialog: false,
      dialogDelete: false,
      scrollSettings: {
        maxScrollbarLength: 160
      }
    }
  },
  watch: {
    match(val) {
      if (val.tournamentId && !this.tabVideoView) {
        this.getOneTournament(val.tournamentId)
      }
    }
  },
  mounted() {
    this.resetLocal()
  },
  computed: {
    ...mapState({
      authUser: state => state.authentication.user,
      matchId: state => state.matches.idSelected,
      match: state => state.matches.matchSelected,
      tournament: state => state.tournaments.selected,
      listUsers: state => state.users.listaUsers
    }),
    time() {
      return (this.localEvent.minute || 0) * 60 + (this.localEvent.second || 0)
    },
    maxMinute() {
      return 59
      return Math.floor(this.duration / 60)
    },
    maxSecond() {
      return 59
      if (this.localEvent.minute == this.maxMinute) {
        return Math.floor(this.duration % 60)
      } else return 59
    },
    type() {
      if (!this.match) return ''
      if (this.match.type == 'user') return 'users'
      else if (
        this.match.type == 'tournament' &&
        (this.tournament.type == 'users' ||
          this.tournament.type == 'usersTeams')
      )
        return 'users'
      else return 'teams'
    },
    teamList() {
      if (!this.match) return []
      let teamList = []
      if (this.match.homeTeamId)
        teamList.push({
          value: this.match.homeTeamId,
          text: this.match.homeTeam
        })
      if (this.match.visitorTeamId)
        teamList.push({
          value: this.match.visitorTeamId,
          text: this.match.visitorTeam
        })

      if (this.isEventsAdmin) return teamList
      else if (this.hasRole('teams'))
        return teamList.filter(team => this.hasRole('teams', team.value))
      else return []
    },
    users() {
      let users = []
      if (this.type == 'users') {
        if (!this.match || !this.match.user || !this.match.userName) return []
        const user = {
          value: this.match.user,
          text: this.match.userName.name,
          photo: process.env.VUE_APP_IMAGE_URL + this.match.userName.photo
        }
        users = [user]
      } else if (this.type == 'teams') {
        if (!this.localEvent.teamId) users = []
        const userTeamList = this.match.participants.filter(user =>
          user.teamIds.includes(this.localEvent.teamId)
        )
        users = userTeamList.map(user => ({
          value: user._id,
          text: user.name,
          photo: process.env.VUE_APP_IMAGE_URL + user.photo
        }))
      }
      if (this.hasRole('teams') && !this.isAdmin)
        users = users.filter(user => this.isTeamManagerOfUser(user.value))
      else if (!this.isEventsAdmin) users = []
      return users
    },
    eventList() {
      let events = []
      if (this.match && this.match.eventsCreated) {
        events = Array.from(this.match.eventsCreated)
        if (this.hasRole('participant')) {
          events = events.filter(
            event =>
              this.hasRole('participant', event.teamId) ||
              event.userId == this.authUser._id
          )
        } else if (this.hasRole('teams')) {
          events = events.filter(event => this.hasRole('teams', event.teamId))
        } else if (!this.isEventsAdmin) {
          events = []
        }
      }

      events = events.map(event => {
        let result = { ...event }
        if (this.type == 'users') {
          result.participant = this.formatParticipant(event.userId)
        } else {
          result.participant = this.formatParticipant(event.teamId)
        }
        return result
      })
      if (events.length == 0 || events.length == 1) return events
      return events.sort((a, b) => this.compare(a, b))
    },
    canCreateEvents() {
      if (this.isEventsAdmin) {
        return true
      }
      let isTeamManager = false
      if (this.type == 'users') {
        isTeamManager = this.isTeamManagerOfUser(this.match.user)
      } else if (this.type == 'teams') {
        isTeamManager =
          this.hasRole('teams', this.match.homeTeamId) ||
          this.hasRole('teams', this.match.visitorTeamId)
      }
      return isTeamManager
    },
    isEventsAdmin() {
      if (!this.match) return false
      let isCreator = this.isCreator(this.match)
      let isTournamentAdmin =
        this.match.tournamentId &&
        this.tournament &&
        this.can('edit', 'tournament', this.tournament)
      let isMatchAdmin = this.can('edit', 'match', this.match)
      let isJudge = this.match.judges.includes(this.authUser._id)
      return (
        this.isAdmin ||
        isCreator ||
        isTournamentAdmin ||
        isJudge ||
        isMatchAdmin
      )
    },
    canEditEvent() {
      if (!this.localEvent._id) return true
      return (
        this.isEventsAdmin || this.authUser._id == this.localEvent.createdBy
      )
    }
  },
  methods: {
    ...mapActions({
      setCreateNew: 'matchEvents/setCreateNew',
      setUpdate: 'matchEvents/setUpdate',
      setDelete: 'matchEvents/setDelete',
      getOneTournament: 'tournaments/setOne'
    }),
    updateTime(time) {
      this.duration = time
    },
    eventTemplate() {
      return {
        teamId: '', // Cuando el evento está relacionado con algún equipo, id del equipo.
        userId: this.match && this.type == 'users' ? this.match.user : '', // Cuando el evento está relacionado con algún jugador, id del user.
        second: 0, // Segundo de creación del evento
        minute: 0, // Segundo de creación del evento
        additionalContent: '', // Contenido adicional del evento.
        likes: [], // Los likes que tiene.
        shared: [] // Las veces compartido que ha sido.
      }
    },
    isValidEvent() {
      const { minute, second, teamId, userId } = this.localEvent
      let error = false
      let messages = []

      if (!Number.isInteger(minute) || minute < 0) {
        error = true
        messages.push(this.$t('error.required', { field: this.$t('minute') }))
      }
      if (minute && minute > this.maxMinute) {
        error = true
        messages.push(
          this.$t('error.maxNumber', {
            field: this.$t('minute'),
            max: this.maxMinute
          })
        )
      }
      if (!Number.isInteger(second) || second < 0) {
        error = true
        messages.push(this.$t('error.required', { field: this.$t('second') }))
      }
      if (second && second > this.maxSecond) {
        error = true
        messages.push(
          this.$t('error.maxNumber', {
            field: this.$t('second'),
            max: this.maxSecond
          })
        )
      }
      if (this.type == 'teams' && !teamId) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('team') }))
      }
      if (this.type == 'users' && !userId) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('user') }))
      }
      if (error) {
        queueToast(messages)
        this.valid = false
        return false
      }
      return true
    },
    addEvent(time) {
      this.resetLocal()
      this.localEvent.minute = Math.floor(time / 60)
      this.localEvent.second = Math.floor(time % 60)
      const vm = this
      setTimeout(() => {
        vm.dialog = true
      }, 50)
    },
    setEvent(event, edit = false) {
      this.resetLocal()
      const vm = this
      setTimeout(() => {
        vm.localEvent = Object.assign({}, event)
        if (edit) vm.dialog = true
      }, 50)
      if (this.isMobile) {
        this.$emit('update:drawer', false)
      }
    },
    saveEvent() {
      if (this.loading || !this.isValidEvent()) return

      let event = { ...this.localEvent }
      let payload = {
        matchId: this.match._id,
        event
      }
      this.loading = true
      if (event._id) {
        this.setUpdate(payload)
          .then(() => (this.dialog = false))
          .finally(() => (this.loading = false))
      } else {
        this.setCreateNew(payload)
          .then(() => (this.dialog = false))
          .finally(() => (this.loading = false))
      }
    },
    deleteEvent() {
      if (this.loadingDelete) return

      const payload = {
        matchId: this.match._id,
        eventId: this.localEvent._id
      }

      this.loadingDelete = true
      this.setDelete(payload).finally(() => {
        this.loadingDelete = false
        this.dialogDelete = false
        this.dialog = false
      })
    },
    resetLocal() {
      this.localEvent = Object.assign({}, this.eventTemplate())
      this.loading = false
      this.valid = true
      this.dialog = false
      this.dialogDelete = false
    },
    compare(a, b) {
      if (a.minute < b.minute) {
        return -1
      }
      if (a.minute > b.minute) {
        return 1
      }
      if (a.second < b.second) {
        return -1
      }
      if (a.second > b.second) {
        return 1
      }
      return 0
    },
    formatParticipant(participantId) {
      let participant = ''
      if (this.type == 'users') {
        if (!Array.isArray(this.users)) return ''
        let user = this.users.find(user => user.value == participantId)
        participant = user ? user.text : '-'
      } else {
        if (!Array.isArray(this.teamList)) return ''
        let team = this.teamList.find(team => team.value == participantId)
        participant = team ? team.text : '-'
      }
      return participant
    },
    isTeamManagerOfUser(userId) {
      if (!this.match || !Array.isArray(this.match.participants)) return false
      let user = this.match.participants.find(user => user._id == userId)
      return !user
        ? false
        : user.teamIds.some(teamId => this.hasRole('teams', teamId))
    }
  }
}
</script>
<style scoped lang="scss">
#appDrawerx {
  overflow: hidden !important;
  // height: calc(100vh - 136px) !important;
  // top: 136px;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
}
</style>
